import { DatePipe } from "@angular/common";
import { ChangeDetectorRef, OnDestroy, Pipe, PipeTransform } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Subscription } from "rxjs";

@Pipe({ name: "localizedDate", pure: false, standalone: true })
export class LocalizedDatePipe implements PipeTransform, OnDestroy {
  private subscription: Subscription;
  private currentLocale: string;

  constructor(
    private translateService: TranslateService,
    private cd: ChangeDetectorRef
  ) {
    this.currentLocale = this.getLocale(this.translateService.currentLang);
    this.subscription = this.translateService.onLangChange.subscribe(({ lang }) => {
      this.currentLocale = this.getLocale(lang);
      this.cd.markForCheck();
    });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  private getLocale(lang: string): string {
    const map: Record<string, string> = { fr: "fr-FR", en: "en-US" };
    return map[lang] ?? "en-US";
  }

  transform(value: Date | string | number, format?: string, timezone?: string): string | null {
    const pipe = new DatePipe(this.currentLocale);
    return pipe.transform(value, format, timezone);
  }
}
